<template>
  <div class="main " v-loading="loading">
    <div class="live width1200">
      <div class="tab">
        <h3>最近直播</h3>
        <div v-for="item in tabList" :class="active === item.value?'active':''" @click="tabs(item.value)">
          {{ item.label }}
        </div>
      </div>
      <div class="content">
        <ul class="list">
          <li v-for="item in list " :key="item.id" @click="goRouter(item.url)">
            <div class="banner">
              <img :src="item.src" alt="">
              <div class="status" :class="['green','org','blue'][item.zhiboType-1]">
                {{ ['招聘', '培训'][item.zhiboType-1] }}
              </div>
            </div>
            <div class="info">
              <h3>{{ item.titile }}</h3>
              <p>
                <span>主讲人：</span><span class="line_clamp1">{{item.perName}}</span>
              </p>
            </div>
            <div class="bottom">
              <div class="time">
                <img src="~/static/henan/time.png" alt="">
                {{ $dateFormat(item.time, 'MM月DD日 hh:mm') }}
              </div>
              <div class="btn">
                <img src="~/static/henan/live.png" alt="" v-if="item.timeStatus == '3'">
                <el-button class="org" v-if="item.timeStatus == '1'">
                  直播预告
                </el-button>
                <el-button class="gray" v-if="item.timeStatus == '2'">
                  直播回放
                </el-button>
                <el-button class="green" v-if="item.timeStatus == '3'">
                  直播中
                </el-button>
              </div>
            </div>
          </li>
        </ul>
        <status type="result" v-if="!loading && list.length === 0"></status>
      </div>
      <div class="pages" v-if="page.total > 0">
        <el-pagination
            background
            class="work_pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, total, jumper"
            prev-text="上一页"
            next-text="下一页"
            :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <login-prompt :goShow="page.isShow" :zhiboId="page.id" @close="handleClose" title="登录" text="登录之后才可以进行操作"></login-prompt>
  </div>
</template>

<script>
import {
  getUserInfo
} from '@/plugins/data.js'
import loginPrompt from "@/components/public/loginPrompt";
export default {
  name: "index",
  components:{loginPrompt},
  data() {
    return {
      tabList: [{label: '全部', value: '0'}, {label: '招聘', value: '1'}, {label: '培训', value: '2'}],
      active: '0',
      page: {
        pageSize: 10,
        pageNum: 1,
        zhiboType: '0',
        timeStatus:'',
        total: 0,
        id:'',
        provinceid: 'p20',
        isShow:false,
      },
      loading: false,
      list: [],
    }
  },
  methods: {
    tabs(index) {
      this.active = index;
      this.page.zhiboType = index;
      this.info();
    },
    info() {
      this.loading = true;
      this.$api.zhiboActivityListApi(this.page).then(res => {
        let {data, msg, success} = res.data;
        this.loading = false;
        if (!success) return this.$message({
          message: msg,
          type: 'warning'
        });
        let {records, total} = data;
        this.list = records;
        this.page.total = total;
      })
    },
    //预约
    getLiveApply(type, id) {
      if (type != '1') return this.$router.push({path: "/activity/live/detail?id=" + id});
      if (getUserInfo()) {
        this.$api.queryAddYuyueApi({zhiboId: id}).then(res => {
          let {msg, success} = res.data;
          if (!success) return this.$message({
            message: msg,
            type: 'warning'
          });
          this.$message({
            message: '预约成功！',
            type: 'success'
          });
          this.info();
        })
      } else {
        this.getLogin(id);
      }
    },
    getLogin() {
      this.page.isShow = true;
    },
    goRouter(url, id) {
      window.open(url, "_blank");
    },
    //分页
    handleCurrentChange: function (val) {
      this.page.pageNum = val;
      this.info();
      window.scrollTo(0, 0);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleClose() {
      this.page.isShow = false;
    }
  },
  created() {
    this.info();
  }
}
</script>

<style scoped lang="scss">
.main {
  background: #FAFCFB;

}

.live {
  padding: 52px 0;

  .tab {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    h3 {
      font-size: 34px;
      font-weight: bold;
      color: #00120A;
      line-height: 50px;
      margin-right: 40px;
    }

    div {
      padding: 6px 13px;
      color: #66716C;
      border: 1px solid rgba(0, 18, 10, 0.1000);
      border-radius: 6px;
      margin-right: 37px;
      margin-top: 3px;
      cursor: pointer;

      &.active {
        color: white;
        border: none;
        background: #28a46d;
      }
    }
  }

  .content {
    .list {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 285px;
        height: 200px;
        background: #FFFFFF;
        box-shadow: 0px 12px 20px 1px rgba(45, 46, 46, 0.12);
        border-radius: 12px 12px 12px 12px;
        margin-right: 20px;
        margin-bottom: 20px;
        overflow: hidden;
        cursor: pointer;
        &:nth-of-type(4n) {
          margin-right: 0;
        }

        .banner {
          position: relative;
          height: 110px;

          img {
            width: 100%;
            height: 100%;
          }

          .status {
            position: absolute;
            top: 10px;
            width: 45px;
            height: 23px;
            background: rgba(24, 150, 70, .72);
            border-radius: 0 12px 12px 0;
            display: flex;
            text-align: center;
            justify-content: center;
            font-size: 10px;
            font-weight: bold;
            color: white;

            &.org {
              background: rgba(255, 150, 0, .72);
            }

            &.gray {
              background: rgba(0, 92, 163, .72);
            }
          }
        }

        .info {
          padding: 5px 0;
          margin: 0 12px;
          border-bottom: 1px solid rgba(0, 18, 10, 0.1000);

          h3 {
            font-size: 14px;
            line-height: 28px;
            font-weight: 800;
          }

          p {
            display: flex;
            font-size: 12px;
            font-weight: 400;
            color: #66716C;
            line-height: 11px;
            padding-bottom: 5px;

            span:last-child {
              flex: 1;
            }
          }
        }

        .bottom {
          display: flex;
          padding: 0 12px;
          align-items: center;
          justify-content: space-between;

          .time {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 500;
            color: #66716C;

            img {
              width: 11px;
              margin-right: 5px;
            }
          }

          .btn {
            img {
              width: 14px;
              vertical-align: middle;
              margin-right: 10px;
            }
          }

          .el-button {
            width: 70px;
            height: 24px;
            font-size: 13px;
            color: white;
            padding: 0;
            margin: 6px 0;
            border: none;
            border-radius: 6px;

            &.green {
              background: #28a46d;
            }

            &.org {
              background: #FF9600;
            }

            &.org1 {
              background: #F5BE71;
            }

            &.gray {
              background: #66716C;
            }
          }
        }
      }
    }
  }
}
</style>